var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap", attrs: { id: "moondayNote" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("h2", { staticClass: "st_title hidden-pad-down" }, [
          _vm._v("共时历笔记")
        ]),
        _c("div", { staticClass: "filterBar" }, [
          _c(
            "div",
            {
              staticClass: "editMoonNote_btn",
              on: {
                click: function($event) {
                  return _vm.editMoonNoteHandler()
                }
              }
            },
            [
              _c("img", {
                staticClass: "hidden-mobile-down",
                attrs: { src: require("@/assets/icon-edit_white.svg"), alt: "" }
              }),
              _c("img", {
                staticClass: "hidden-mobile-up",
                attrs: { src: require("@/assets/icon-edit_gold.svg"), alt: "" }
              })
            ]
          )
        ])
      ]),
      _vm.astroCalendarNote
        ? _c("div", { staticClass: "moondayNoteDetail" }, [
            _c(
              "div",
              {
                staticClass: "moondayNoteDetail__header",
                class: { infoWrap: _vm.splitMoods.length > 2 }
              },
              [
                _c(
                  "div",
                  { staticClass: "moondayNoteDetail__header__moodsGroup" },
                  _vm._l(_vm.splitMoods, function(mood, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "moondayNoteDetail__header__moodsGroup__mood",
                        style:
                          "background-color:" +
                          _vm.emotionList.find(function(e) {
                            return e.id === mood
                          }).color +
                          " "
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.emotionList.find(function(e) {
                              return e.id === mood
                            }).active_icon,
                            alt: ""
                          }
                        })
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "moondayNoteDetail__header__content" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "moondayNoteDetail__header__content__title"
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.astroCalendarNote.Title) +
                            "\n        "
                        )
                      ]
                    ),
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            "" +
                              _vm
                                .moment(_vm.astroCalendarNote.Date)
                                .format("yyyy-MM-DD")
                          ) +
                          "\n        "
                      )
                    ])
                  ]
                ),
                _c("img", {
                  staticClass: "pic2",
                  attrs: {
                    src: require("@/assets/月亮日記/筆記裝飾星星大.svg"),
                    alt: ""
                  }
                }),
                _c("img", {
                  staticClass: "pic3",
                  attrs: {
                    src: require("@/assets/月亮日記/筆記裝飾星星小.svg"),
                    alt: ""
                  }
                })
              ]
            ),
            _c("div", { staticClass: "moondayNoteDetail__body" }, [
              _c("h2", [_vm._v("我的心情")]),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.replaceBr(_vm.astroCalendarNote.MoodContent)
                  )
                }
              }),
              _c("h2", [_vm._v("我的笔记")]),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.replaceBr(_vm.astroCalendarNote.Content)
                  )
                }
              })
            ]),
            _c("div", { staticClass: "moondayNoteDetail__share" }, [
              _c(
                "div",
                {
                  staticClass: "moondayNoteDetail__share__btn",
                  on: {
                    click: function($event) {
                      _vm.openDownloadImg = true
                    }
                  }
                },
                [
                  _c("span", [_vm._v("分享")]),
                  _c("img", {
                    attrs: {
                      src: require("@/assets/月亮日記/分享.svg"),
                      alt: ""
                    }
                  })
                ]
              )
            ]),
            _c("div", { staticClass: "moondayNoteDetail__btn" }, [
              _c(
                "div",
                {
                  staticClass: "moondayNoteDetail__btn__pre",
                  class: {
                    disable: !_vm.astroCalendarNote.PreviousCalendarNoteId
                  },
                  on: {
                    click: function($event) {
                      return _vm.toNote(false)
                    }
                  }
                },
                [_vm._v("\n        上一则\n      ")]
              ),
              _c(
                "div",
                {
                  staticClass: "moondayNoteDetail__btn__next",
                  class: { disable: !_vm.astroCalendarNote.NextCalendarNoteId },
                  on: {
                    click: function($event) {
                      return _vm.toNote(true)
                    }
                  }
                },
                [_vm._v("\n        下一则\n      ")]
              )
            ])
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "moondayNoteGoBack hidden-pad-up",
          on: {
            click: function($event) {
              return _vm.$router.push("/astroCalendar?tab=note")
            }
          }
        },
        [_vm._v("\n    返回笔记列表\n  ")]
      ),
      _vm.astroCalendarNote && _vm.openDownloadImg
        ? _c("AstroCalendarDownload", {
            attrs: { astroCalendarNote: _vm.astroCalendarNote },
            on: {
              close: function($event) {
                _vm.openDownloadImg = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }